import axios from 'axios';

const axiosInstance = () => axios.create({
  baseURL: window.location.origin,
});

const methods = {
  getAutoComplete: (query) => axiosInstance().get(`/api/search/autocomplete/?query=${query}&productsSize=3`),
};

export default methods;
